import { render, staticRenderFns } from "./QuadrilleBackground.vue?vue&type=template&id=72c0d52e"
import script from "./QuadrilleBackground.vue?vue&type=script&lang=js"
export * from "./QuadrilleBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports